declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { GenericProcPostRequest, FeaturesController, GetFeatureDetailsRequest, S_Methods, SaveFeatureDetailsRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { ModuleData } from '../../../../../../src/app/ncs/models/actor/actor';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';






@Component({
  selector: 'features',
  templateUrl: './features.component.html',
  styleUrls: [
    './features.component.scss']
  , animations: [routerTransition()]
})

export class FeaturesComponent implements OnInit {

  
  public ShowList: boolean = true;
  public ShowList2: boolean = false;
  public AddFeature: boolean = false;
  public EditFeature: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
  public searchText: any;
  public ApiResData: ApiResponseModel;



  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService,
    private tosterservice: NGXToastrService) { }

  ngOnInit() {
    this.GetModulesList();


  }

  modules: ModuleData[];

  GetModulesListController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.actorservice.generic_proc_post(this.mreq)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.modules = JSON.parse(this.ApiResData.Result);
          // alert(this.modules.length);
          //this.pdata = this.CurrentStoreLocationMaterialsController;
          //this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  GetModulesList() {
    this.mreq = new GenericProcPostRequest();
    this.mreq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.mreq.ConditionalOperator = 1002;
    this.mreq.QueryData = "1";
    //http://healins.cloudapp.net/k1newapi/els/1002/1
    //http://healins.cloudapp.net/k1newapi/els/1002/a=123,b=77
    this.GetModulesListController();

  }
  public SelectedModuleId: string;
  mreq: GenericProcPostRequest;
  SelectedModuleDetails: ModuleData;
  SelectedModule(obj: any) {
    var Module: ModuleData = obj;
    if (Module != null) {
      this.SelectedModuleDetails = null;
      this.SelectedModuleDetails = Module;
      this.ShowList = true;
      this.ShowList2 = true;
      //this.CurrentAccessRightsByRoleController = null;
      this.LoadFeatures(this.SelectedModuleDetails.ModuleID);

    }

  }

  CurrentFeaturesController: FeaturesController[];  
  LoadFeatures(MiD: string) {
    var getReq = new GetFeatureDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101045;
    //getReq.Branch = AppData.Instance().SelectedBranchCode;
    getReq.ModuleID = MiD;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101045;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentFeaturesController = JSON.parse(data);          
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();

          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
          //this.LoadStoragedata();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  public Name: string;
  public ShortName: string;
  public Description: string;
  public FeatureType: string;
  public Status: string;
  SelectedValue: string;
  SelectedStatus: string;
  onChange(event: any) {
    this.SelectedValue = event;
  }
  onChange2(event: any) {
    this.SelectedStatus = event;
  }
  SaveData() {
    var saveReq = new SaveFeatureDetailsRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40390;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    saveReq.Name = this.Name;
    saveReq.ShortName = this.ShortName;
    saveReq.ModuleID = this.SelectedModuleDetails.ModuleID;
    saveReq.Description = this.Description;
    saveReq.FeatureType = this.FeatureType;
    saveReq.Status = this.Status;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40390;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            //this.activeModal.close();
            this.Cancel1();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  SelectedFeatures() {
    this.ShowList = true;
    this.ShowList2 = true;
    this.AddFeature = false;
    this.EditFeature = false;
  }
  AddNewFeature() {
    this.ShowList = true;
    this.ShowList2 = false;
    this.AddFeature = true;
    this.EditFeature = false;
  }
  EditFeat() {
    this.ShowList = true;
    this.ShowList2 = false;
    this.AddFeature = false;
    this.EditFeature = true;
  }
  Cancel1() {
    this.ShowList = true;
    this.ShowList2 = true;
    this.AddFeature = false;
    this.EditFeature = false;
  }
  Cancel2() {
    this.ShowList = true;
    this.ShowList2 = true;
    this.AddFeature = false;
    this.EditFeature = false;
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


}
